import { getTheme, IRawStyle, IStyle, ITheme, mergeStyles } from '@fluentui/react';
import { FunctionComponent } from 'react';

type ContentDescription = 'primary content (no subcontent)' | 'side menus and subcontent' | 'tab menu and subcontent';

interface IBwjPageContentProps {
  contentDescription: ContentDescription;
  backgroundColor?: string;
  style?: IRawStyle;
}

interface IBwjSubcontentProps {
  backgroundColor?: string;
  style?: IRawStyle;
}

const getPageStyles = (theme: ITheme, backgroundColor?: string) => {
  const contentBase: IStyle = {
    flexGrow: 1,
    backgroundColor: backgroundColor ?? theme.palette.neutralLighterAlt,
  };

  const principalContent: IStyle = {
    ...contentBase,
    padding: 20,
    paddingBottom: 96,
    display: 'flex',
    flexDirection: 'column',
  };

  const withSideMenuSubcontent: IStyle = {
    ...contentBase,
    display: 'flex',
    flexDirection: 'row',
  };

  const withTabMenuSubcontent: IStyle = {
    ...contentBase,
    padding: 20,
    display: 'flex',
    flexDirection: 'column',
  };

  const tabMenuSubcontent: IStyle = {
    ...contentBase,
    display: 'flex',
    flexDirection: 'column',
    paddingTop: 20,
    paddingBottom: 96,
  };

  const sideMenuSubcontent: IStyle = {
    ...contentBase,
    padding: 20,
    paddingBottom: 96,
    display: 'flex',
    flexDirection: 'column',
  };

  return {
    principalContent,
    withSideMenuSubcontent,
    withTabMenuSubcontent,
    tabMenuSubcontent,
    sideMenuSubcontent,
  };
}

export const BwjPageContent: FunctionComponent<IBwjPageContentProps> = (props) => {
  const theme = getTheme();
  const styles = getPageStyles(theme, props.backgroundColor);
  const styleSet = props.contentDescription === 'primary content (no subcontent)' ? [styles.principalContent] :
  props.contentDescription === 'side menus and subcontent' ? [styles.withSideMenuSubcontent] :
  [styles.withTabMenuSubcontent];

  if(!!props.style) {
    styleSet.push(props.style);
  }
  const className = mergeStyles(styleSet);

  return (
    <div className={className}>
        {props.children}
    </div>
  );
};

export const BwjTabMenuSubcontent: FunctionComponent<IBwjSubcontentProps> = (props) => {
  const theme = getTheme();
  const styleSet = [getPageStyles(theme, props.backgroundColor).tabMenuSubcontent];

  if(!!props.style) {
    styleSet.push(props.style);
  }
  const className = mergeStyles(styleSet);

  return (
    <section className={className}>
        {props.children}
    </section>
  );
};

export const BwjSideMenuSubcontent: FunctionComponent<IBwjSubcontentProps> = (props) => {
  const theme = getTheme();
  const styleSet = [getPageStyles(theme, props.backgroundColor).sideMenuSubcontent];

  if(!!props.style) {
    styleSet.push(props.style);
  }
  const className = mergeStyles(styleSet);

  return (
    <section className={className}>
        {props.children}
    </section>
  );
};